// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1T3cM","col":"styles_col__l7J_Y"};